import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { generateRoutes } from '@/utils/permission'
import { loadMenusOnce } from '@/utils/menuService'

Vue.use(ElementUI)
Vue.config.productionTip = false

let hasFetchedRoutes = false
let isRegisteringRoutes = false

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('Auth-Token')
  const publicPaths = ['/login', '/sso/fastadmin']

  if (token) {
    if (to.path === '/login') {
      next({ path: '/' })
      return
    }

    if (to.path === '/sso/fastadmin') {
      next()
      return
    }

    if (!hasFetchedRoutes && !isRegisteringRoutes) {
      try {
        isRegisteringRoutes = true
        const menuTree = await loadMenusOnce()

        const accessRoutes = generateRoutes(menuTree)
        hasFetchedRoutes = true
        if (typeof router.addRoutes === 'function') {
          router.addRoutes(accessRoutes)
        } else {
          accessRoutes.forEach(route => {
            router.addRoute(route)
          })
        }
        next({
          path: to.path,
          query: to.query,
          hash: to.hash,
          replace: true
        })
      } catch (error) {
        hasFetchedRoutes = false
        localStorage.removeItem('Auth-Token')
        localStorage.removeItem('User-Info')
        // 菜单服务会自己清理缓存，这里只清理登录态
        next('/login')
      } finally {
        isRegisteringRoutes = false
      }
    } else {
      next()
    }
  } else if (publicPaths.includes(to.path)) {
    next()
  } else {
    next('/login')
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
